var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _path3, _path4, _rect0, _rect1, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveDonationCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 124,
    viewBox: "0 0 164 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 162,
    height: 122,
    rx: 5,
    fill: "#F0F9F5",
    stroke: "#68C598",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.75,
    y: 17.75,
    width: 48.5,
    height: 88.5,
    rx: 3.25,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 90,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 51.5C32 50.6716 32.6716 50 33.5 50H46V53H33.5C32.6716 53 32 52.3284 32 51.5Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50H60.5C61.3284 50 62 50.6716 62 51.5C62 52.3284 61.3284 53 60.5 53H48V50Z",
    fill: "#BBBBBB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 56,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 60,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69.5C32 68.6716 32.6716 68 33.5 68H46V71H33.5C32.6716 71 32 70.3284 32 69.5Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 68H60.5C61.3284 68 62 68.6716 62 69.5C62 70.3284 61.3284 71 60.5 71H48V68Z",
    fill: "#BBBBBB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 74,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 78,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 40H95V85H140V40ZM138.058 42.025H97.0263V83.0875H138.058V42.025Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.063 71.2765L112.147 57.9023L99.29 77.1881H116.925L116.857 77.2854H134.857L125.857 64.4282L121.063 71.2765Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.488 60.5848C131.362 60.5848 133.691 58.2791 133.691 55.435C133.691 52.5908 131.362 50.2852 128.488 50.2852C125.615 50.2852 123.286 52.5908 123.286 55.435C123.286 58.2791 125.615 60.5848 128.488 60.5848Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDonationCard);
export default __webpack_public_path__ + "static/media/active-donation-card.3a1da898b2f0c45184b3cb419d90f54b.svg";
export { ForwardRef as ReactComponent };